import { Pipe, PipeTransform } from '@angular/core';
import * as _ from 'lodash';
/**
 * Generated class for the FormatPricePipe pipe.
 *
 * See https://angular.io/api/core/Pipe for more info on Angular Pipes.
 */
@Pipe({
  name: 'formatTemp',
})
export class FormatTempPipe implements PipeTransform {
  /**
   * Takes a job and displays the compensation in a human readable format Based
   * on the following fields:

   */

  formatTemp = function(value) {
    return _.round((value - 273.15) * 1.8 + 32);
  };

  transform(value: any, ...args) {
    return this.formatTemp(value);
  }
}



// WEBPACK FOOTER //
// ./src/pipes/format-temp/format-temp.ts